import {THREE} from "./resource/three.js";
import {owayoUtils} from "./owayoUtils";

type XY = {x:number, y:number}

const vA = new THREE.Vector3(),
    vB = new THREE.Vector3(),
    vC = new THREE.Vector3(),

    uvA = new THREE.Vector2(),
    uvB = new THREE.Vector2(),
    uvC = new THREE.Vector2(),
    isPointLeftOfLine = function (linePointA: XY, linePointB: XY, pointToTest: XY): 0 | 1 | -1 {
        // result 0 on line
        //       -1 left
        //        1  right
        return Math.sign((linePointB.x - linePointA.x) * (pointToTest.y - linePointA.y) - (linePointB.y - linePointA.y) * (pointToTest.x - linePointA.x)) as 0 | 1 | -1;
    };

let a: number, b: number, c: number;//, tmpFace;


export function isUVCoordinateInFaceUV(mesh: THREE.Mesh, faceIndex: number, pointToTest: XY): {
    isUVInFace: boolean;
    coordinateOnObject: { x: number; y: number; z: number }
} {
    let uvs: number[],
        tmpFace: { materialIndex: string | number; a: string | number; b: string | number; c: string | number; };
    const result = {isUVInFace: false, coordinateOnObject: null as { x: number, y: number, z: number } | null},
        geometry = mesh.geometry;
    let material = mesh.material;
    if (material === undefined) {
        return;
    }

    if (geometry instanceof THREE.BufferGeometry) {

        const attributes = geometry.attributes,
            positions = attributes.position.array;
        uvs = attributes.uv.array;

        // Indexed-BufferGeometry
        if (geometry.index) {

            const indices = geometry.index.array;

            a = (indices[faceIndex * 3]);
            b = (indices[faceIndex * 3 + 1]);
            c = (indices[faceIndex * 3 + 2]);

        } else {
            a = faceIndex * 3;
            b = faceIndex * 3 + 1;
            c = faceIndex * 3 + 2;
        }

        vA.fromArray(positions, a * 3);
        vB.fromArray(positions, b * 3);
        vC.fromArray(positions, c * 3);

        uvA.fromArray(uvs, a * 2);
        uvB.fromArray(uvs, b * 2);
        uvC.fromArray(uvs, c * 2);

    } else if (mesh.geometry instanceof THREE.Geometry) {

        tmpFace = geometry.faces[faceIndex];
        uvs = geometry.faceVertexUvs;

        const isFaceMaterial = mesh.material instanceof THREE.MeshFaceMaterial,
            objectMaterials = (isFaceMaterial === true ? mesh.material.materials : null);
        material = (isFaceMaterial === true ? objectMaterials[tmpFace.materialIndex] : mesh.material);

        if (material === undefined) {
            return;
        }
        const vertices = geometry.vertices;

        a = vertices[tmpFace.a];
        b = vertices[tmpFace.b];
        c = vertices[tmpFace.c];

        vA.set(0, 0, 0);
        vB.set(0, 0, 0);
        vC.set(0, 0, 0);

        // if (material.morphTargets === true) {
        //     const morphTargets = geometry.morphTargets,
        //         morphInfluences = mesh.morphTargetInfluences;
        //
        //
        //     for (let t = 0, tl = morphTargets.length; t < tl; t++) {
        //         const influence = morphInfluences[t];
        //
        //         if (influence === 0) {
        //             return;
        //         }
        //
        //         const targets = morphTargets[t].vertices;
        //
        //         vA.x += (targets[tmpFace.a].x - a.x) * influence;
        //         vA.y += (targets[tmpFace.a].y - a.y) * influence;
        //         vA.z += (targets[tmpFace.a].z - a.z) * influence;
        //
        //         vB.x += (targets[tmpFace.b].x - b.x) * influence;
        //         vB.y += (targets[tmpFace.b].y - b.y) * influence;
        //         vB.z += (targets[tmpFace.b].z - b.z) * influence;
        //
        //         vC.x += (targets[tmpFace.c].x - c.x) * influence;
        //         vC.y += (targets[tmpFace.c].y - c.y) * influence;
        //         vC.z += (targets[tmpFace.c].z - c.z) * influence;
        //
        //     }
        //
        // }

        vA.add(a);
        vB.add(b);
        vC.add(c);

        uvA.fromArray(uvs, faceIndex * 3 * 2);
        uvB.fromArray(uvs, faceIndex * 3 * 2 + 2);
        uvC.fromArray(uvs, faceIndex * 3 * 2 + 4);


    } else {
        console.error('isUVCoordinateInFaceUV: The type of the geometry is not supported.');
        return;
    }


    if ((isPointLeftOfLine(uvA, uvB, pointToTest) > 0) &&
        (isPointLeftOfLine(uvB, uvC, pointToTest) > 0) &&
        (isPointLeftOfLine(uvC, uvA, pointToTest) > 0)) {

        // We have found a positive result.
        result.isUVInFace = true;

        result.coordinateOnObject = owayoUtils.calculate3DcoordinateOfUVIntersectionPoint(uvA, uvB, uvC, pointToTest, vA, vB, vC);
    }
    return result;

}
